/**
 * Query keys for the machines table.
 *
 * The table renders unscoped, scoped to an entity, scoped to a case, or scoped
 * to both. caseRouteId is the case as named in the route, which the entity and
 * case detail pages resolve differently, so it stays a separate segment field.
 */
export const machineKeys = {
  all: ["machines"],
  lists: () => [...machineKeys.all, "list"],
  list: ({ entityId = null, caseId = null, caseRouteId = null } = {}) => [
    ...machineKeys.lists(),
    { entityId, caseId, caseRouteId },
  ],
};
